<template>
  <div class="cdetchitolaw">
    <sub-title text="诚邀话题解答律师" />
    <div class="hualist">
      <chitolawitem class="huaitem" v-for="(item, index) in 3" :key="index" />
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
import chitolawitem from "../components/chitolawitem";
export default {
  components: {
    subTitle,
    chitolawitem,
  },
};
</script>

<style lang="scss" scoped>
.cdetchitolaw {
  width: 100%;
  padding: 30px 25px;
  .hualist {
    .huaitem {
      border-bottom: 1px solid #ccc;
      &:last-child{
      border-bottom: none  ;
      }
    }
  }
}
</style>